
import DropDownMenuProfile from '../DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../DropDown/DropDownMenuItem';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import TableFunction from '../table/TableFunction';
import {MODEL_LANGUAGE} from './Model/Models';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const CustomMenuLanguage = () => {

    const modelList = Object.entries(MODEL_LANGUAGE).map(([key, value]) => ({
        id: key,
        ...value
    }));

    const { i18n } = useTranslation();
    const currentLanguageCode = Cookies.get('i18next') || 'en';
    const [currentLanguage, setCurrentLanguage] = useState(modelList.find((l) => l.code === currentLanguageCode));
    const mobileBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--bp-is-mobile').trim();
    const mobileBreakpointValue = parseInt(mobileBreakpoint, 10);
    const isMobile = typeof window !== 'undefined' && window.innerWidth < mobileBreakpointValue;

    const { t, openMenu, handleMenuToggle, handleClose } =
        TableFunction({});

    const changeLanguage = (langCode) => {
        i18n.changeLanguage(langCode);
        Cookies.set('i18next', langCode, { expires: 365 });
        setCurrentLanguage(modelList.find((l) => l.code === langCode))
    };

    return (
        <>
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId='profile-menu'
                name={isMobile ? currentLanguage?.transMd : currentLanguage?.trans}
                isAccordion={true}
                className={'col-12 col-md-6 p-0'}
                extraClassName={'btn-dropdown-general-950'}
                IconAdditional={currentLanguage?.Icon || null}
                isLeftIconArrow={false}
            >
                {modelList.map((lang) => (
                    <DropDownMenuItem
                        id={`btn_cml_${lang.code}`}
                        key={lang.code}
                        name={t(`${isMobile ? lang?.transMd : lang?.trans}`)}
                        icon={<lang.Icon fontSize='small' />}
                        handleClose={handleClose}
                        click={() => changeLanguage(lang.code)}
                    />
                ))}
            </DropDownMenuProfile>
        </>
    )

}

export default CustomMenuLanguage
